import { Tabs } from '@/shared/components/ui';
import styles from './TabsPage.module.css';

export const TabsPage = () => {
    const basicTabs = [
        {
            id: 'tab1',
            label: 'Tab 1',
            content: <div><p>Contenido del Tab 1. Aquí puedes mostrar cualquier información relevante.</p></div>
        },
        {
            id: 'tab2',
            label: 'Tab 2',
            content: <div><p>Contenido del Tab 2. Cambia entre tabs para ver el contenido diferente.</p></div>
        },
        {
            id: 'tab3',
            label: 'Tab 3',
            content: <div><p>Contenido del Tab 3. Los tabs son perfectos para organizar información.</p></div>
        },
    ];

    const profileTabs = [
        {
            id: 'perfil',
            label: 'Perfil',
            content: (
                <div>
                    <h3>Información del Perfil</h3>
                    <p><strong>Nombre:</strong> Juan Pérez</p>
                    <p><strong>Email:</strong> juan@ejemplo.com</p>
                    <p><strong>Rol:</strong> Administrador</p>
                </div>
            )
        },
        {
            id: 'configuracion',
            label: 'Configuración',
            content: (
                <div>
                    <h3>Configuración</h3>
                    <p>Aquí puedes ajustar tus preferencias de usuario.</p>
                    <ul>
                        <li>Notificaciones por email</li>
                        <li>Idioma de la interfaz</li>
                        <li>Zona horaria</li>
                    </ul>
                </div>
            )
        },
        {
            id: 'seguridad',
            label: 'Seguridad',
            content: (
                <div>
                    <h3>Seguridad</h3>
                    <p>Gestiona la seguridad de tu cuenta.</p>
                    <ul>
                        <li>Cambiar contraseña</li>
                        <li>Autenticación de dos factores</li>
                        <li>Sesiones activas</li>
                    </ul>
                </div>
            )
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>Tabs</h1>
                <p className={styles.description}>
                    Componente Tabs para organizar contenido en pestañas navegables.
                    Perfecto para formularios complejos, dashboards y vistas con múltiples secciones.
                </p>
            </div>

            {/* Tabs Básicos */}
            <section className={styles.section}>
                <h2>Tabs Básicos</h2>
                <p>Tabs simples con contenido de texto.</p>

                <div className={styles.example}>
                    <Tabs items={basicTabs} />

                    <code className={styles.code}>
                        {`const tabs = [
  {
    id: 'tab1',
    label: 'Tab 1',
    content: <div>Contenido del Tab 1...</div>
  },
  {
    id: 'tab2',
    label: 'Tab 2',
    content: <div>Contenido del Tab 2...</div>
  },
  {
    id: 'tab3',
    label: 'Tab 3',
    content: <div>Contenido del Tab 3...</div>
  },
];

<Tabs items={tabs} />`}
                    </code>
                </div>
            </section>

            {/* Tab por Defecto */}
            <section className={styles.section}>
                <h2>Tab Activo por Defecto</h2>
                <p>Puedes especificar cuál tab debe estar activo inicialmente.</p>

                <div className={styles.example}>
                    <Tabs items={basicTabs} defaultTab="tab2" />

                    <code className={styles.code}>
                        {`<Tabs items={tabs} defaultTab="tab2" />`}
                    </code>
                </div>
            </section>

            {/* Ejemplo Práctico */}
            <section className={styles.section}>
                <h2>Ejemplo Práctico: Perfil de Usuario</h2>
                <p>Tabs con contenido más complejo y estructurado.</p>

                <div className={styles.example}>
                    <Tabs items={profileTabs} />

                    <code className={styles.code}>
                        {`const profileTabs = [
  {
    id: 'perfil',
    label: 'Perfil',
    content: (
      <div>
        <h3>Información del Perfil</h3>
        <p><strong>Nombre:</strong> Juan Pérez</p>
        <p><strong>Email:</strong> juan@ejemplo.com</p>
      </div>
    )
  },
  {
    id: 'configuracion',
    label: 'Configuración',
    content: (
      <div>
        <h3>Configuración</h3>
        <p>Ajusta tus preferencias...</p>
      </div>
    )
  },
  {
    id: 'seguridad',
    label: 'Seguridad',
    content: (
      <div>
        <h3>Seguridad</h3>
        <p>Gestiona la seguridad...</p>
      </div>
    )
  },
];

<Tabs items={profileTabs} />`}
                    </code>
                </div>
            </section>

            {/* Casos de Uso */}
            <section className={styles.section}>
                <h2>Casos de Uso</h2>

                <div className={styles.useCases}>
                    <div className={styles.useCase}>
                        <h3>Formularios Multi-Step</h3>
                        <p>Divide formularios largos en secciones más manejables usando tabs.</p>
                    </div>

                    <div className={styles.useCase}>
                        <h3>Dashboards</h3>
                        <p>Organiza diferentes vistas de datos (gráficos, tablas, reportes) en tabs.</p>
                    </div>

                    <div className={styles.useCase}>
                        <h3>Configuraciones</h3>
                        <p>Agrupa configuraciones relacionadas en tabs temáticos.</p>
                    </div>

                    <div className={styles.useCase}>
                        <h3>Detalles de Entidades</h3>
                        <p>Muestra información general, historial, documentos, etc. en tabs separados.</p>
                    </div>
                </div>
            </section>

            {/* Props */}
            <section className={styles.section}>
                <h2>Props</h2>
                <div className={styles.propsTable}>
                    <table>
                        <thead>
                            <tr>
                                <th>Prop</th>
                                <th>Tipo</th>
                                <th>Default</th>
                                <th>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>items</code></td>
                                <td><code>TabItem[]</code></td>
                                <td>-</td>
                                <td>Array de tabs (requerido)</td>
                            </tr>
                            <tr>
                                <td><code>defaultTab</code></td>
                                <td><code>string</code></td>
                                <td><code>items[0].id</code></td>
                                <td>ID del tab activo por defecto</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 style={{ marginTop: '2rem', marginBottom: '1rem' }}>TabItem Interface</h3>
                <div className={styles.propsTable}>
                    <table>
                        <thead>
                            <tr>
                                <th>Propiedad</th>
                                <th>Tipo</th>
                                <th>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>id</code></td>
                                <td><code>string</code></td>
                                <td>Identificador único del tab</td>
                            </tr>
                            <tr>
                                <td><code>label</code></td>
                                <td><code>string</code></td>
                                <td>Texto que se muestra en el tab</td>
                            </tr>
                            <tr>
                                <td><code>content</code></td>
                                <td><code>ReactNode</code></td>
                                <td>Contenido que se muestra al seleccionar el tab</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            {/* Import */}
            <section className={styles.section}>
                <h2>Importación</h2>
                <code className={styles.code}>
                    {`import { Tabs } from '@/shared/components/ui';
import type { TabItem } from '@/shared/components/ui';`}
                </code>
            </section>
        </div>
    );
};
